import { createdUpdatedAtValueFormat, formatColumnNames } from "./StringFormatHelper"

export const displayNestedValues = (object, index) => {
    return <ul className="list-group w-100">
    {Object.entries(object).map((nestedVal, nestedIndex) => {
        return <li className="list-group-item" key={`${index}-${nestedIndex}`}>
            {formatColumnNames(nestedVal[0])}: {!nestedVal[1] ? "/" : typeof (nestedVal[1]) !== "object" ? <>{nestedVal[0] === "created_at" || nestedVal[0] === "updated_at" ? createdUpdatedAtValueFormat(nestedVal[1]) : isNaN(Number(nestedVal[1])) ? nestedVal[1].toString() : Number(nestedVal[1])}</> : nestedVal[1] &&
            displayNestedValues(nestedVal[1], nestedIndex)}
        </li>
    })}
</ul>
}